import { holdingStrategy } from 'enums/holdingStrategy'
import { soldByChannel } from 'enums/soldByChannel'
import { storageStatus } from 'enums/storageStatus'
import { loweIndex } from 'enums/loweIndex'
import { FILTER_TYPES } from 'store/modules/common/filters'
import { api as storagePlacesApi } from 'store/modules/lookups/storagePlaces'
import { api as regionsApi } from 'store/modules/lookups/regions'
import { api as countriesApi } from 'store/modules/lookups/countries'
import { api as districtsApi } from 'store/modules/lookups/districts'
import { api as subdistrictsApi } from 'store/modules/lookups/subdistricts'
import { api as wineTypesApi } from 'store/modules/lookups/wineTypes'
import { api as classificationByOriginsApi } from 'store/modules/lookups/classificationByOrigins'
import { api as classificationByParamsesApi } from 'store/modules/lookups/classificationByParamses'

export const AVAILABLE_COLUMNS_SIMPLE = [
  { id: 'alcohol', type: FILTER_TYPES.numeric },
  { id: 'acidity', type: FILTER_TYPES.numeric },
  { id: 'sugar', type: FILTER_TYPES.numeric },
  { id: 'expQuality', type: FILTER_TYPES.numeric },
  { id: 'dateOfArrival', type: FILTER_TYPES.date },
  { id: 'expiration', type: FILTER_TYPES.numeric },
  { id: 'dateOfSale', type: FILTER_TYPES.date },
  { id: 'dateOfOrder', type: FILTER_TYPES.date },
  { id: 'storageLocation', type: FILTER_TYPES.numeric },
  { id: 'description', type: FILTER_TYPES.string },
  { id: 'wineName', type: FILTER_TYPES.string },
  { id: 'supplierName', type: FILTER_TYPES.string },
  { id: 'holdingStrategy', type: FILTER_TYPES.enum, enum: holdingStrategy },
  { id: 'soldByChannel', type: FILTER_TYPES.enum, enum: soldByChannel },
  { id: 'status', type: FILTER_TYPES.enum, enum: storageStatus },
  { id: 'storagePlaceId', type: FILTER_TYPES.lookup, api: storagePlacesApi },
  { id: 'regionId', type: FILTER_TYPES.lookup, api: regionsApi },
  { id: 'countryId', type: FILTER_TYPES.lookup, api: countriesApi },
  { id: 'districtId', type: FILTER_TYPES.lookup, api: districtsApi },
  { id: 'subdistrictId', type: FILTER_TYPES.lookup, api: subdistrictsApi },
  { id: 'wineTypeId', type: FILTER_TYPES.lookup, api: wineTypesApi },
  { id: 'classificationByOriginId', type: FILTER_TYPES.lookup, api: classificationByOriginsApi },
  { id: 'classificationByParamsId', type: FILTER_TYPES.lookup, api: classificationByParamsesApi }
]

export const AVAILABLE_COLUMNS = [
  ...AVAILABLE_COLUMNS_SIMPLE,
  { id: 'loweIndex',  type: FILTER_TYPES.enum, enum: loweIndex },
  { id: 'customerRating', type: FILTER_TYPES.numeric },
  { id: 'temperature', type: FILTER_TYPES.numeric },
  { id: 'acquisitionPrice', type: FILTER_TYPES.numeric },
  { id: 'actualPrice', type: FILTER_TYPES.numeric },
]
